<template>
  <div>
    <v-btn
      color="warning"
      variant="tonal"
      @click="openModalFindNomorKas = true"
    >
      Edit Pengeluaran
    </v-btn>
    <v-row>
      <v-col cols="12" md="6">
        <v-container class="py-0 px-0" id="hide">
          <v-card tile>
            <v-card-title>
              <h2>
                {{ formData.nomor_kas ? "Edit" : "" }} Pengeluaran Operasional
              </h2>
              <h2>
                {{
                  formData.nomor_kas ? ", Nomor Kas: " + formData.nomor_kas : ""
                }}
              </h2>
            </v-card-title>
            <v-card-text class="py-0">
              <v-container class="px-0">
                <v-row>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-text-field
                      label="Tanggal"
                      dense
                      small-chips
                      hide-details
                      type="date"
                      v-model="formData.tgl"
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-select
                      label="Jenis Kas"
                      v-model="formData.jenis_kas"
                      :items="['masuk', 'keluar']"
                      hide-details
                      dense
                    ></v-select>
                  </v-col> -->
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-autocomplete
                      label="Kategori"
                      :items="items.kategori"
                      :loading="loading.fetchKategori"
                      :disabled="loading.fetchKategori"
                      v-model="formData.kategori"
                      dense
                      hide-details
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-autocomplete
                      v-model="formData.oleh"
                      label="Oleh"
                      :items="items.karyawan"
                      :loading="loading.fetchKaryawan"
                      :disabled="loading.fetchKaryawan"
                      hide-details
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-autocomplete
                      v-model="formData.acc"
                      label="ACC"
                      :items="items.karyawan"
                      :loading="loading.fetchKaryawan"
                      :disabled="loading.fetchKaryawan"
                      hide-details
                      dense
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-text-field
                      label="KC"
                      dense
                      small-chips
                      hide-details
                      type="text"
                      v-model="formData.kc"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-text-field
                      label="KV"
                      dense
                      small-chips
                      hide-details
                      type="text"
                      v-model="formData.kv"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-text-field
                      label="Jumlah"
                      dense
                      small-chips
                      hide-details
                      type="text"
                      v-model="jumlah"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="8" class="fit-content">
                    <v-text-field
                      label="Untuk Keperluan"
                      dense
                      small-chips
                      hide-details
                      type="text"
                      v-model="formData.keperluan"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="fit-content">
                    <v-checkbox
                      v-model="formData.selesai"
                      label="Selesai (Masuk Pelaporan Pajak)"
                      hide-details
                      dense
                    ></v-checkbox>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="fit-content d-flex justify-end"
                  >
                    <v-btn
                      color="warning"
                      v-if="formData.nomor_kas"
                      @click="resetEditFormState"
                      tabindex="2"
                      class="mr-2"
                    >
                      Cancel Edit
                    </v-btn>
                    <v-btn
                      color="error"
                      @click="resetFormData"
                      tabindex="2"
                      class="mr-2"
                    >
                      Reset
                    </v-btn>
                    <v-btn
                      color="primary"
                      :loading="loading.saveData"
                      :disabled="loading.saveData"
                      @click="saveData"
                      v-if="!formData.nomor_kas"
                    >
                      Simpan
                    </v-btn>
                    <v-btn
                      color="primary"
                      :loading="loading.saveData"
                      :disabled="loading.saveData"
                      @click="saveUpdatedData"
                      v-if="formData.nomor_kas"
                    >
                      Update
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-container>
      </v-col>
    </v-row>

    <!-- Modal Find Nomor Kas -->
    <v-dialog v-model="openModalFindNomorKas" max-width="290">
      <v-card>
        <v-card-title class="text-h6">
          Masukkan Nomor Kas
        </v-card-title>

        <v-container>
          <v-text-field
            v-model="nomor_kas"
            @keydown.enter="fetchKas"
            :loading="loading.findDataKas"
            label="Nomor Kas"
            outlined
            hide-details
            autofocus
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>

    <main class="report" v-if="receiptData.id" id="section-print">
      <div class="header">
        <div class="left">
          <h6>TANDA TERIMA</h6>
          <p>{{ receiptData.kategori }}</p>
        </div>
        <div class="right">
          <p>{{ receiptData.id }}</p>
        </div>
      </div>
      <div class="content">
        <div class="line">
          <p>Tanggal</p>
          <p>{{ formatDate(receiptData.tgl) }}</p>
        </div>
        <div class="line">
          <p>Dikeluarkan Oleh</p>
          <p>{{ receiptData.oleh.nama }}</p>
        </div>
        <div class="line">
          <p>ACC</p>
          <p>{{ receiptData.acc.nama }}</p>
        </div>
        <div class="line">
          <p>Keperluan</p>
          <p>{{ receiptData.keperluan }}</p>
        </div>
        <div class="line">
          <p>Total</p>
          <b>Rp{{ formatCurrency(Math.abs(receiptData.nominal)) }}</b>
        </div>
      </div>
      <div class="ttd">
        <div>
          <p>Diserahkan Kepada,</p>

          <p class="nama">{{ receiptData.oleh.nama }}</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { sync } from "vuex-pathify";

export default {
  name: "ContainerModal",
  data() {
    return {
      loading: {
        fetchKaryawan: false,
        fetchKategori: false,
        saveData: false,
        findDataKas: false
      },
      openModalFindNomorKas: false,
      nomor_kas: "",
      formData: {
        nomor_kas: "",
        jenis_kas: "keluar",
        tgl: "",
        kategori: "",
        oleh: "",
        acc: "",
        kc: "",
        kv: "",
        jumlah: 0,
        keperluan: "",
        selesai: true
      },
      TTPBKembaliHeaders: [
        { text: "TTPB", value: "ttpb" },
        { text: "Tanggal", value: "tgl" },
        { text: "Penerima", value: "penerima" },
        { text: "Pengantar", value: "pengantar" },
        { text: "Kondisi", value: "kondisi_penerimaan" },
        { text: "Catatan", value: "catatan" }
      ],
      TTPBKembali: [],
      items: {
        karyawan: [],
        kategori: []
      },
      receiptData: {}
    };
  },
  computed: {
    jumlah: {
      get() {
        return this.formatCurrency(this.formData.jumlah);
      },
      set(val) {
        return (this.formData.jumlah = this.convertToAngka(val));
      }
    }
  },
  watch: {
    "formData.kc"(val) {
      if (val) {
        this.formData.kc = val.toUpperCase();
      }
    },
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  methods: {
    async fetchKas() {
      if (!this.nomor_kas) {
        alert("Nomor kas tidak boleh kosong");
        return;
      }

      this.loading.findDataKas = true;

      axios
        .get(`kas/biaya-lain/${this.nomor_kas}`)
        .then(res => {
          this.formData.nomor_kas = res.data.id;
          this.formData.jenis_kas = res.data.jenis;
          this.formData.tgl = new Date(res.data.tgl)
            .toISOString()
            .substr(0, 10);
          this.formData.kategori = res.data.kategori;
          this.formData.oleh = parseInt(res.data.oleh);
          this.formData.acc = parseInt(res.data.acc);
          this.formData.kc = res.data.kc;
          this.formData.kv = res.data.kv;
          this.formData.jumlah = Math.abs(res.data.nominal);
          this.formData.keperluan = res.data.keterangan;
          const selesaiValue = res.data.selesai;
          this.formData.selesai =
            selesaiValue === null || selesaiValue === undefined
              ? true
              : selesaiValue === true ||
                selesaiValue === 1 ||
                selesaiValue === "1";

          this.loading.findDataKas = false;
          this.openModalFindNomorKas = false;
        })
        .catch(err => {
          this.loading.findDataKas = false;

          alert(err.response.data.message);
        });
    },
    async fetchData() {
      this.loading.TTPBKembali = true;

      axios
        .get("ttpb-kembali")
        .then(res => {
          this.TTPBKembali = res.data;

          this.loading.TTPBKembali = false;
        })
        .catch(err => {
          this.loading.TTPBKembali = false;

          alert(err.response.data.message);
        });
    },
    async saveData() {
      this.loading.saveData = true;

      await axios
        .post(`kas/biaya-lain`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.receiptData = res.data.data;

          setTimeout(() => {
            window.print();
          }, 500);

          this.fetchKategori();
          this.resetFormData();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    async saveUpdatedData() {
      this.loading.saveData = true;

      await axios
        .put(`kas/biaya-lain/${this.formData.nomor_kas}`, this.formData)
        .then(res => {
          this.loading.saveData = false;
          this.receiptData = res.data.data;

          setTimeout(() => {
            window.print();
          }, 500);

          this.fetchKategori();
          this.resetEditFormState();
        })
        .catch(err => {
          this.loading.saveData = false;

          alert(err.response.data.message);
        });
    },
    async fetchKaryawan() {
      this.loading.fetchKaryawan = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.items.karyawan = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.fetchKaryawan = false;
        })
        .catch(err => {
          this.loading.fetchKaryawan = false;

          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      this.loading.fetchKategori = true;

      await axios
        .get(`master-data?kategori=kategori_pengeluaran`)
        .then(res => {
          this.items.kategori = res.data.map(data => data.nama);

          this.loading.fetchKategori = false;
        })
        .catch(err => {
          this.loading.fetchKategori = false;

          alert(err.response.data.message);
        });
    },
    resetEditFormState() {
      this.formData.nomor_kas = "";
      this.formData.jenis_kas = "keluar";
      this.formData.tgl = "";
      this.formData.kategori = "";
      this.formData.oleh = "";
      this.formData.acc = "";
      this.formData.kc = "";
      this.formData.kv = "";
      this.formData.jumlah = 0;
      this.formData.keperluan = "";
      this.formData.selesai = true;

      this.nomor_kas = "";
    },
    resetFormData() {
      this.formData.jenis_kas = "keluar";
      this.formData.tgl = "";
      this.formData.kategori = "";
      this.formData.oleh = "";
      this.formData.acc = "";
      this.formData.kc = "";
      this.formData.kv = "";
      this.formData.jumlah = 0;
      this.formData.keperluan = "";
      this.formData.selesai = true;
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}/${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}/${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    }
  },
  created() {
    this.fetchKaryawan();
    this.fetchKategori();
  }
};
</script>

<style scoped>
@media print {
  #section-print {
    /* width: 80mm 600mm; */
    width: 80mm auto;
  }
}

@page {
  /* size: 80mm 600mm; */
  size: 80mm auto;
}

#section-print {
  display: none;
  font-size: 14px;
  width: 80mm;
  /* height: 600mm; */
  height: auto;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.left h6 {
  font-size: 14px;
  text-decoration: underline;
  margin: 0;
  padding: 0;
}

.right p {
  border: 1px solid black;
  padding: 3px 10px;
}

.line {
  display: flex;
  justify-content: space-between;
}

.line p {
  margin: 2px 0;
}

.ttd {
  margin-top: 1rem;
  display: flex;
  justify-content: end;
}

.ttd .nama {
  margin-top: 4rem;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}

.fit-content {
  height: fit-content;
}

table {
  border-collapse: collapse;
  width: 100%;
}

table th,
table td {
  font-size: 12px !important;
  border: 1px solid gray !important;
  padding: 0 2px;
}

table th {
  background-color: #f5f5f5;
}

table.no-border th,
table.no-border td {
  border: none !important;
}

.input {
  border: 1px solid lightgray;
  padding: 1px 4px;
  outline: none;
  width: 100%;
}

.w-100 {
  width: 100%;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

.no-wrap {
  white-space: nowrap;
}

.without_ampm::-webkit-datetime-edit-ampm-field {
  display: none;
}

input[type="time"]::-webkit-clear-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -ms-appearance: none;
  appearance: none;
  margin: -10px;
}
</style>
